(function ($) {
    
  $(document).ready(function () {
    var swiper = new Swiper(".support-slider", {
      slidesPerView: 3,
      spaceBetween: 22,
      loop: false,
      centeredSlides: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
  
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 10,
          loop: false,
          centeredSlides: true,
        },
        750: {
          loop: false,
          slidesPerView: 3,
          spaceBetween: 22,
          centeredSlides: false,
        },
        // 1024: {
        //   slidesPerView: 5,
        //   spaceBetween: 50,
        // },
      },
    });

    
    let swiperInstance;
    let formulaSwiperInstance;
    
    function initMobileSwiper() {
      const isMobile = window.innerWidth < 750;
    
      if (isMobile) {
        if (!swiperInstance) {
          swiperInstance = new Swiper('.landing-logos-slider .swiper', {
            loop: true,
            freeMode: true,
            autoplay: {
              delay: 0,
              disableOnInteraction: false,
            },
            loopAddBlankSlides: true,
            slidesPerView: 2.5,
            speed: 5000,
            grabCursor: true,
            loopAdditionalSlides: 2,
          });
        }
    
        if (!formulaSwiperInstance) {
          formulaSwiperInstance = new Swiper(".formula-science-slider", {
            slidesPerView: 1,
            spaceBetween: 22,
            loop: false,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
          });
        }
      } else {
        if (swiperInstance) {
          swiperInstance.destroy(true, true);
          swiperInstance = undefined;
        }
    
        if (formulaSwiperInstance) {
          formulaSwiperInstance.destroy(true, true);
          formulaSwiperInstance = undefined;
        }
      }
    }
    
    window.addEventListener('load', initMobileSwiper);
    window.addEventListener('resize', initMobileSwiper);
    
    
    $(".story-tab-sec .tabs_item_wrapper .tab-item .button").click(function () {
      var tabId = $(this).parents(".tab-item").attr("data-target");
      $(".story-tab-sec .tabs_item_wrapper .tab-item .button").removeClass(
        "active"
      );
      $(".story-tab-sec .tabs-content_wrapper .tab-content").removeClass(
        "active"
      );
      $(this).addClass("active");
      $("#" + tabId).addClass("active");
    });
    $(
      ".story-tab-sec .tabs_item_wrapper .tab-item:first-of-type .button"
    ).click();
  
    $(".multitabs .tabs_item_wrapper .tab-item .button").click(function () {
      var tabId = $(this).parents(".tab-item").attr("data-target");
      $(".multitabs .tabs_item_wrapper .tab-item .button").removeClass("active");
      $(".multitabs .tabs-content_wrapper .tab-content").removeClass("active");
      $(this).addClass("active");
      $("#" + tabId).addClass("active");
    });
    $(".multitabs .tabs_item_wrapper .tab-item:first-of-type .button").click();


    /*----------------header-------------------*/
    $("header summary.header__menu-item").on("mouseenter", function () {
        const $this = $(this);
        const $megaMenu = $this.closest(".mega-menu");
        const $content = $this.next(".mega-menu__content");
        // Toggle aria-expanded and add active class
        if ($this.attr("aria-expanded") === "true") {
            $this.removeAttr("aria-expanded");
            $megaMenu.removeAttr("open");
        } else {
            $this.attr("aria-expanded", "true");
            $megaMenu.attr("open", "true");
        }
    });

    // Close menu on mouse leave
    $(".mega-menu").on("mouseleave", function () {
        $(this).removeAttr("open").find("summary.header__menu-item").removeAttr("aria-expanded");
    });


    $('.product .modify-box li, .bundle-includes li').prepend(`<span class="tick-icon"><svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.75 7.09473L6.125 11.4697C9.875 6.46973 13 2.09473 13 2.09473" stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
</svg></span>`);

      /*------------------popup-------------------*/
    $('.product .modify-box .custom-text').click(function (e) {
        e.preventDefault();
        $(this).closest('.modify-box').find('.modal-popup-container').addClass('active');
    })
    $('.product .card-bundle-sdk .modal-popup-container .icon-close').click(function (e) {
        e.preventDefault();
        $(this).closest('.modal-popup-container').removeClass('active');
    })
    $(document).click(function(event){
      var len = $(event.target).closest('.modal-popup-container, .custom-text').length;
      if(!len){
        $('.modal-popup-container').removeClass('active');
      }
    })

    /*----------------account desktop popup ------------------*/
      const $icon = $('.header-account-menu .header__icon--account');
      const $menu = $('.header-account-menu .menu-drawer__menu');
    
      $icon.on('click', function (e) {
        e.preventDefault();
        $menu.addClass('active');
      });
    
      $(document).on('click', function (e) {
        if (!$icon.is(e.target) && !$menu.is(e.target) && !$menu.has(e.target).length) {
          $menu.removeClass('active');
        }
      });

       const inputSelector = '.custom-product-bundle .selling_plan_option input';
        const activeClass = 'selected';
        $(inputSelector).on('change', function () {
          $('.custom-product-bundle .selling_plan_option').removeClass(activeClass);
          if ($(this).is(':checked')) {
            $(this).closest('.selling_plan_option').addClass(activeClass);
          }
        });
        $(inputSelector + ':checked').each(function () {
          $(this).closest('.selling_plan_option').addClass(activeClass);
        });
  });
  
  $(window).on("load resize", function () {
    var winWidth = $(window).width();
    if (winWidth < 750) {
      $(".need-info-sec .multicolumn-card__info .inline-richtext").append(
        '<span class="toggle-btn"></span>'
      );
      $(".need-info-sec .multicolumn-card__info .inline-richtext").click(
        function () {
          $(this).toggleClass("active").siblings(".rte").slideToggle();
        }
      );
      $(
        ".need-info-sec .multicolumn-card__info:first-of-type .inline-richtext"
      ).click();
    }
    var containerWidth = $(".page-width-desktop").width();
    var padding = (winWidth - 1370) / 2;
    if (winWidth > 1370) {
      $(".touch-with-right .page-width-desktop").css("padding-left", padding);
    } else if (winWidth > 750) {
      $(".touch-with-right .page-width-desktop").css("padding-left", "7rem");
    } else {
      $(".touch-with-right .page-width-desktop").css("padding-left", "2rem");
    }
  
    //console.log(containerWidth);
  });
})(jQuery);


// Function to handle drawer opening and closing
function handleCartDrawerState() {
  //console.log('Cart drawer state changed');
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && cartDrawer.classList.contains('active')) {
    document.documentElement.classList.add('minicart-open');
  } else {
    document.documentElement.classList.remove('minicart-open');
  }
}

// Function to modify the HTML when the recharge-bundles widget is loaded
// function modifyRechargeBundles() {
//   const rechargeBundles = document.querySelector('.rb-form');
//   if (rechargeBundles) {
//     let bundleTitle = document.querySelector('.rb-bundle-title');
//     let incentivesContainer = document.querySelector('.rb-incentives-status__container');
//     if (bundleTitle && incentivesContainer) {
//       let parent = incentivesContainer.parentNode;
//       parent.insertBefore(bundleTitle, incentivesContainer);
//     } else {
//       console.error('Required elements not found in the DOM.');
//     }

//     let bundleDescription = document.querySelector('.rb-bundle-description');
//     if (bundleDescription) {
//       let parent = rechargeBundles.parentNode;
//       parent.insertBefore(bundleDescription, rechargeBundles);
//     } else {
//       console.error('Required elements not found in the DOM.');
//     }
//   }
// }



document.addEventListener("DOMContentLoaded", function () {
  const stickyBtn = document.querySelector('.sticky-cta-sec');

  const bannerSection = document.querySelector('.banner-landing-page');
  const formulaSection = document.querySelector('.formula-science-section');
  const bundleSection = document.querySelector('.custom-product-bundle');
  const supportSection = document.querySelector('.custom-journey-support');
  const shopNowActionButtons = document.querySelectorAll('a.button.button--primary[href="#landing-featured-product"]:not([data-ele="sticky-button"]), .card-bundle-sdk .bundle-collection-actions');
  
  

  function isPast(el) {
    if (!el) return false;
    return el.getBoundingClientRect().bottom < 0;
  }

  function isInView(el) {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  }

  function handleStickyBtn() {
    let anyButtonVisible = false;
    shopNowActionButtons.forEach(button => {
      if (isInView(button)) {
        anyButtonVisible = true;
      }
    });
    if (anyButtonVisible) {
      stickyBtn.style.display = 'none';
    } else {
      stickyBtn.style.display = 'block';
    }
  }
  
  /*
  function handleScrollMobile() {
    const pastBanner = isPast(bannerSection);
    const inFormula = isInView(formulaSection);
    const inBundle = isInView(bundleSection);
    const inSupport = isInView(supportSection);
    
    if (inSupport || inBundle || inFormula || !pastBanner) {
      stickyBtn.style.display = 'none';
    } else {
      stickyBtn.style.display = 'block';
    }
  }
  */

  window.addEventListener('scroll', () => {
    if (!stickyBtn) return;
    handleStickyBtn();
  });
});




function modifyRechargeBundles() {
  const rechargeBundles = document.querySelector('.rb-sticky-form .rb-form');
  if (rechargeBundles) {
    let rbHeader = document.querySelector('.rb-header');
    let bundleTitle = document.querySelector('.rb-bundle-title');
    let bundleDescription = document.querySelector('.rb-bundle-description');
    let incentivesContainer = document.querySelector('.rb-incentives-status__container');
    let rbStickyForm = document.querySelector('.rb-sticky-form');
    let existingBuildBoxHeader = document.querySelector('.build-a-box-header');
    let productsContainer = document.querySelector('.rb-box-builder');
    if (existingBuildBoxHeader) {
      return;
    }
    if (bundleTitle && incentivesContainer && rbStickyForm) {
      let buildBoxHeaderEle = document.createElement('div');
      buildBoxHeaderEle.className = 'build-a-box-header';
      let buildBoxHeaderInnerEle = document.createElement('div');
      buildBoxHeaderInnerEle.className = 'build-a-box-header-inner';
      buildBoxHeaderEle.appendChild(buildBoxHeaderInnerEle);

      let headerColumnEleLeft = document.createElement('div');
      headerColumnEleLeft.className = 'build-a-box-header-column column-left';

      let headerColumnEleRight = document.createElement('div');
      headerColumnEleRight.className = 'build-a-box-header-column column-right';

      headerColumnEleLeft.appendChild(bundleTitle);
      headerColumnEleLeft.appendChild(incentivesContainer);
      
      let formParent = rechargeBundles.parentNode;
      formParent.insertBefore(bundleDescription, rechargeBundles);
      headerColumnEleRight.appendChild(rbStickyForm);
      

      buildBoxHeaderInnerEle.appendChild(headerColumnEleLeft);
      buildBoxHeaderInnerEle.appendChild(headerColumnEleRight);

      let parent = rbHeader.parentNode;
      parent.insertBefore(buildBoxHeaderEle, rbHeader);

      let heading = document.createElement('h2');
      heading.textContent = "What’s In Your Bundle";
      productsContainer.insertBefore(heading, productsContainer.firstChild);
      
    } else {
      console.error('Required elements not found in the DOM.');
    }
  }
}

let rbFormFound = false;

const observer = new MutationObserver((mutationsList) => {
  for (let mutation of mutationsList) {
    // Check for class changes in the cart-drawer
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
      handleCartDrawerState();
    }

    // Check for the addition of the recharge-bundles widget, but only if it hasn't been found yet
    if (!rbFormFound && mutation.type === 'childList') {
      if (document.querySelector('.rb-form')) {
        modifyRechargeBundles();
        rbFormFound = true;
      }
    }
  }
});

// Observe the document body for child changes (for recharge-bundles) and attribute changes (for cart-drawer)
observer.observe(document.body, { attributes: true, childList: true, subtree: true });



document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('.header .help-content-block').forEach(menu => {
    menu.style.display = 'none';
  });

  document.querySelectorAll('.header .help-label-block').forEach(button => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      const content = button.nextElementSibling;
      const caret = button.querySelector('.collapsible-icon');
      const isOpen = content.style.display === 'block';

      // Close all other menus and reset caret rotation
      document.querySelectorAll('.header .help-content-block').forEach(menu => {
        menu.style.display = 'none';
      });
      document.querySelectorAll('.header .help-label-block .collapsible-icon').forEach(icon => {
        icon.classList.remove('rotate');
      });

      // Toggle current menu
      content.style.display = isOpen ? 'none' : 'block';

      // Toggle caret rotation
      if (!isOpen) {
        caret.classList.add('rotate');
      } else {
        caret.classList.remove('rotate');
      }
    });
  });

  document.querySelector('#Details-menu-drawer-resources-quizzes .menu-drawer__menu-item')?.click();
});

// document.addEventListener("DOMContentLoaded", function () {
//     const details = document.getElementByClassName("header__menu-item");
//     details.addEventListener("mouseenter", function () {
//       details.parents('.mega-menu').setAttribute("open", "true");
//     });
//     details.addEventListener("mouseleave", function () {
//       details.removeAttribute("open");
//     });
// });
